export class RequestQueryParams {
    ids: any[];
    queryString: {
        [key: string]: any;
    }
}

